var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 211,
    viewBox: "0 0 259 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 153C31.6457 134.78 55.5089 6.18203 72.0089 0.182026C88.5089 -5.81797 130.509 138.506 137.509 138.506C142.509 140.006 215.509 65.182 227.009 64.682C238.509 64.182 236 145 239.5 154C243 163 233.869 165.313 228.5 169C228.5 144 221.5 172.5 214 156.5C216.5 147 216.509 108.006 216.509 97.182C191.009 118.682 155.429 159 155 162C154.013 168.906 137.463 157.147 137.498 171.403C137.505 171.597 137.509 171.796 137.509 172C137.502 171.796 137.499 171.597 137.498 171.403C136.895 154.973 111.064 174.79 116.5 157C122.5 143 83.9999 58.5 78.5 46C75.5 36 47.4999 147.5 48.4999 159C48.1028 162.84 46.829 166.469 45.1521 170L21.1923 168.5C19.4339 163.632 19.0371 158.597 21.9999 153Z",
    fill: "#80E614"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 181.5,
    r: 19.5,
    stroke: "#80E614",
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 181.5,
    r: 19.5,
    stroke: "#80E614",
    strokeWidth: 20
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.5,
    cy: 181.5,
    r: 19.5,
    stroke: "#80E614",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.66c4694eaf6d599509401193deab2ab3.svg";
export { ForwardRef as ReactComponent };